import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the run sheet; each part uses its own slice of it */
import styles from './Rollout.module.scss';
/* eslint-enable css-modules/no-unused-class */

export type MilestoneKind = 'releaseDay' | 'youtube' | 'manual' | 'done' | 'locked';

const KIND_CLASS: Record<MilestoneKind, string | undefined> = {
  releaseDay: undefined,
  youtube: styles.milestoneYt,
  manual: styles.milestoneMan,
  done: styles.milestoneDone,
  locked: styles.milestoneLocked,
};

interface MilestoneRowProps {
  kind: MilestoneKind;
  /** "Day 0", "00:00", "+1". */
  when: string;
  day: string;
  isLast: boolean;
  children: React.ReactNode;
}

/** A milestone of the run sheet (design rollout-plan `.stp.ms`): a diamond on the line and a dashed row, not a card. */
const MilestoneRowComponent: React.FC<MilestoneRowProps> = ({ kind, when, day, isLast, children }) => (
  <div className={clsx(styles.stp, styles.milestone, KIND_CLASS[kind], isLast && styles.last)}>
    <div className={clsx(styles.when, kind === 'releaseDay' && styles.whenZero)}>
      <b>{when}</b>
      <small>{day}</small>
    </div>
    <div className={styles.node}>
      <i />
    </div>
    <div className={styles.body}>
      <div className={clsx(styles.msr, kind === 'releaseDay' && styles.msrZero)}>{children}</div>
    </div>
  </div>
);

export const MilestoneRow = TypedMemo(MilestoneRowComponent);
